import React from 'react';
import {Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Typography} from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import {useTranslation} from 'react-i18next';
import {useQueryClient} from 'react-query';
import FormSubmissions from '../../marketing/forms/FormSubmissions';
import GenerateLinkContent from '../../marketing/forms/GenerateLinkContent';

interface Props {
    open: boolean;
    onClose: () => void;
    sectorId?: string;
    profileId?: string;
}

const ReservationFormSelectorDialog: React.FC<Props> = ({open, onClose, sectorId, profileId}) => {
    const {t} = useTranslation();
    const queryClient = useQueryClient();

    const handleRefresh = () => {
        queryClient.invalidateQueries(['forms-list']);
        queryClient.invalidateQueries(['form-submissions']);
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="lg"
            fullWidth
        >
            <DialogTitle sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                {t('Forms & Surveys')}
                <Button onClick={handleRefresh} startIcon={<RefreshIcon/>} size="small">
                    {t('Refresh')}
                </Button>
            </DialogTitle>
            <DialogContent>
                <GenerateLinkContent
                    profileId={profileId}
                    sectorId={sectorId}
                    enabled={open}
                    qrCodeElementId="reservation-form-qr-code-svg"
                />

                {profileId && (
                    <>
                        <Divider sx={{my: 3}}/>
                        <Box>
                            <Typography variant="subtitle1" gutterBottom>
                                {t('Past submissions')}
                            </Typography>
                            <FormSubmissions profileId={profileId} hideActionBar/>
                        </Box>
                    </>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>{t('Close')}</Button>
            </DialogActions>
        </Dialog>
    );
};

export default ReservationFormSelectorDialog;
